import React, { ElementType, forwardRef, HTMLAttributes } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export interface CCardHeaderProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * A string of all className you want applied to the base component.
   */
  className?: string
  /**
   * Component used for the root node. Either a string to use a HTML element or a component.
   */
  component?: string | ElementType
}

export const CCardHeader = forwardRef<HTMLDivElement, CCardHeaderProps>(
  ({ children, component: Component = 'div', className, ...rest }, ref) => {
    return (
      <Component className={classNames('card-header', className)} {...rest} ref={ref}>
        {children}
      </Component>
    )
  },
)

CCardHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  component: PropTypes.elementType,
}

CCardHeader.displayName = 'CCardHeader'
